export const SENDING_TYPE_NOW = 'now'
export const SENDING_TYPE_SCHEDULE = 'schedule'
